import { getFileUrl } from 'utils/helper';
import { GRAPHQL_QUERY } from 'utils/contentful/graphqlQuery';
import { contentfulClient, fallbackClient } from 'utils/contentful/client';
import { PAGES_EXCLUDE_SEARCH, PAGES_FALLBACK_CONTENTFUL, SEARCH_ARTICLES_LIMIT } from 'utils/constants';
import { getGraphqlResultPages } from 'utils/contentful/helper';
import { handleError } from 'utils/error';
import baseApi, { BASEQUERY_TYPES } from '.';

const pageApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchPage: builder.query({
      async queryFn(value) {
        if (!value) {
          return { data: {} };
        }

        const client = PAGES_FALLBACK_CONTENTFUL.includes(value) ? fallbackClient : contentfulClient;

        try {
          const response = await client.getEntries({
            contentType: 'page',
            additionalQueryParams: {
              'fields.slug': value,
            },
          });
          const data = response?.items?.[0]?.fields || {};

          return {
            data: {
              ...data,
              metaData: {
                metaTitle: data.metaTitle || '',
                metaDescription: data.metaDescription || '',
                metaRobots: data.metaRobots || '',
                ogImage: getFileUrl(data.ogImage),
              },
            },
          };
        } catch (e) {
          handleError(e);

          return { error: e.message };
        }
      },
    }),
    getPageSearchResult: builder.query({
      extraOptions: {
        type: BASEQUERY_TYPES.graphql,
      },
      async queryFn(value, _, __, baseQuery) {
        if (!value) {
          return { data: [] };
        }

        try {
          const byText = await baseQuery(
            GRAPHQL_QUERY.loadPreviewPages({
              limit: SEARCH_ARTICLES_LIMIT,
              where: {
                pageTitle_contains: value,
                slug_not_in: PAGES_EXCLUDE_SEARCH,
              },
            }),
          );

          const result = [...getGraphqlResultPages(byText.data)];

          return { data: result };
        } catch (e) {
          handleError(e);

          return { error: e.message };
        }
      },
    }),
    getPageSearchResultFallback: builder.query({
      extraOptions: {
        type: BASEQUERY_TYPES.graphql,
        client: fallbackClient,
      },
      async queryFn(value, _, __, baseQuery) {
        if (!value) {
          return { data: [] };
        }

        try {
          const byText = await baseQuery(
            GRAPHQL_QUERY.loadPreviewPages({
              limit: SEARCH_ARTICLES_LIMIT,
              where: {
                pageTitle_contains: value,
                slug_not_in: PAGES_EXCLUDE_SEARCH,
              },
            }),
          );

          const result = [...getGraphqlResultPages(byText.data)];

          return { data: result };
        } catch (e) {
          handleError(e);

          return { error: e.message };
        }
      },
    }),
  }),
});

export const {
  useFetchPageQuery,
  useGetPageSearchResultQuery,
  useGetPageSearchResultFallbackQuery,
} = pageApi;

export default pageApi;
